exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.tw-news_news_2xF72 {\n    background: var(--motion-tertiary);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.375rem 0;\n    gap: 0.5rem;\n}\n\n.tw-news_text_1OE4I {\n    flex-grow: 1;\n    color: white;\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.tw-news_text_1OE4I a {\n    color: inherit;\n}\n\n.tw-news_close_3iAN3 {\n    flex-shrink: 0;\n    margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"news": "tw-news_news_2xF72",
	"text": "tw-news_text_1OE4I",
	"close": "tw-news_close_3iAN3"
};